import { render } from "./AutoProfileAI2.vue?vue&type=template&id=108a429a&scoped=true"
import script from "./AutoProfileAI2.vue?vue&type=script&lang=js"
export * from "./AutoProfileAI2.vue?vue&type=script&lang=js"

import "./AutoProfileAI2.vue?vue&type=style&index=0&id=108a429a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-108a429a"]])

export default __exports__